<template>
  <v-container>
    <AppLoader :loading="loadingCnpj" message="Consultando CNPJ" />
    <v-dialog v-model="dialogProtocolo" max-width="400">
      <v-card>
        <!-- <v-toolbar class="elevation-0" color="primary" dark> Informações </v-toolbar> -->

        <v-card-title class="justify-center">
          <strong>Detalhes da Solicitação</strong>
        </v-card-title>
        <v-card-subtitle class="text-center pt-1">
          Existe uma solicitação em andamento.
        </v-card-subtitle>
        <v-card-text class="">
          <div><strong>Nº do Protocolo:</strong> {{ solicitacao.id || '-' }}</div>
          <div><strong>Situação:</strong> {{ formatSituacao(solicitacao.status) }}</div>
          <div><strong>Data de Criação:</strong> {{ solicitacao.createdDate || '-' }}</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" text @click="dialogProtocolo = false"> Fechar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-btn class="primary--text mt-0 mb-5" @click="clearTipoSelecionado" text
      ><v-icon>arrow_back</v-icon>Voltar</v-btn
    >
    <v-form ref="form">
      <v-row class="-mt-5 justify-center">
        <v-col class="input-text" cols="12" md="6">
          <br />
          <v-text-field
            v-model="formattedCnpj"
            :rules="[rules.required, rules.cnpjValid]"
            maxlength="18"
            class="input-text mt-5"
            label="CNPJ"
            outlined
            dense
            append-icon="search"
            :loading="loadingCnpj"
            style="width: '50%' !important"
            @input="searchCnpj"
            placeholder="Digite o CNPJ *"
          />
        </v-col>
        <v-col cols="12" md="12">
          <v-alert :type="alertMsg ? 'info' : 'warning'" outlined border="left"  class="mt-2">
            {{
              alertMsg
                ? 'Para iniciar a solicitação, digite o CNPJ no campo acima. Caso já exista uma solicitação em andamento para este CNPJ, aguarde a finalização antes de iniciar uma nova.'
                : 'Todos os campos são obrigatórios.'
            }}
          </v-alert>
        </v-col>
      </v-row>
      <v-row class="-mt-5">
        <v-col v-if="showForm" class="input-text" cols="12" md="6">
          <v-text-field
            v-model="formSolicitacao.nomeEmpresa"
            :rules="[rules.required]"
            class="mr-2"
            label="Razão Social *"
            outlined
            dense
            :disabled="
              formSolicitacao.tipoSolicitacao == 'CONSUMIDOR_CATIVO_LIVRE'
                ? !!formSolicitacao.nomeEmpresa
                : false
            "
          />
        </v-col>
        <v-col v-if="showForm" class="input-text" cols="12" md="6">
          <v-text-field
            :value="formatarTipoSolicitacao(formSolicitacao)"
            :rules="[rules.required]"
            class="mr-2"
            label="Tipo de Solicitação *"
            outlined
            dense
            disabled
          />
        </v-col>
        <v-col v-if="showForm" class="input-text" cols="12" md="6">
          <v-text-field
            v-model="formSolicitacao.email"
            :rules="[rules.email, rules.required]"
            label="Email *"
            outlined
            dense
            :disabled="
              formSolicitacao.tipoSolicitacao == 'CONSUMIDOR_CATIVO_LIVRE'
                ? !!formSolicitacao.email
                : false
            "
          />
        </v-col>
        <v-col v-if="showForm" class="input-text" cols="12" md="6">
          <v-text-field
            v-model="formSolicitacao.telefone"
            v-mask="['(##) #####-####', '(##) ####-####']"
            :rules="[rules.required]"
            class="ml-2"
            label="Telefone *"
            outlined
            dense
            :disabled="
              formSolicitacao.tipoSolicitacao == 'CONSUMIDOR_CATIVO_LIVRE'
                ? !!formSolicitacao.telefone
                : false
            "
          />
        </v-col>
        <v-col v-if="showForm" class="input-text" cols="12" md="12">
          <v-text-field
            v-model="formSolicitacao.endereco"
            :rules="[rules.required]"
            label="Endereço *"
            outlined
            dense
            :disabled="
              formSolicitacao.tipoSolicitacao == 'CONSUMIDOR_CATIVO_LIVRE'
                ? !!formSolicitacao.endereco
                : false
            "
          />
        </v-col>
        <v-col v-if="showForm" class="input-text" cols="12" md="12">
          <v-text-field
            v-model="formSolicitacao.prepostoEmpresa"
            :rules="[rules.required]"
            label="Preposto da Empresa no Estado do Ceará (Nome)"
            type="text"
            pattern="[A-Za-zÀ-ÿ\s]+"
            oninput="this.value = this.value.replace(/[^A-Za-zÀ-ÿ\s]/g, '')"
            outlined
            dense
            :disabled="
              formSolicitacao.tipoSolicitacao == 'CONSUMIDOR_CATIVO_LIVRE'
                ? !!formSolicitacao.prepostoEmpresa
                : false
            "
          />
        </v-col>
        <!-- Card do documento para download -->
        <v-col
          v-if="formSolicitacao.tipoSolicitacao === 'COMERCIALIZADOR' && showForm"
          cols="12"
          md="12"
        >
          <span style="font-size: 0.9rem; font-weight: 400; color: grey"
            >Faça download do arquivo para assinatura.</span
          >
          <v-card class="pa-2 ma-0" outlined style="width: 100%; min-height: 40px">
            <v-card-title
              class="d-flex justify-space-between align-center pa-2"
              style="min-height: 40px"
            >
              <span style="font-size: 0.85rem">Termo de Compromisso para Fins de Autorização de Comercializador.</span><br />
              <v-btn icon color="primary" @click="baixarDocumento()">
                <v-tooltip top>
                  <template #activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on"> download </v-icon>
                  </template>
                  <span>Baixar Documento</span>
                </v-tooltip>
              </v-btn>
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import AppLoader from '@/components/AppLoader.vue';
import { mapState, mapMutations, mapActions } from 'vuex';
import {
  formatAlphanumericCNPJ,
  normalizeAlphanumericCNPJ,
  validateAlphanumericCNPJ,
} from '@/helpers/cnpj-alphanumeric.validator';
import ServiceSolicitacao from '@/services/spgc/solicitacao.service';
import solicitacao from '@/store/modules/solicitacao';
import moment from 'moment';
import {
  formSolicitacao,
  possuiSolicitacaoEmAndamento,
} from '@/store/modules/spgc/states/solicitacao';
import situacoesSolicitacao from '../enums/situacoes-solicitacao';
import GlobalStore from '@/store/modules/global';

export default {
  name: 'StepUmDadosSolicitante',
  components: { AppLoader },
  props: {
    documentos: {
      type: Array,
      default: () => [],
    },
    resetting: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      documentoSelecionado: null,
      dialogProtocolo: false,
      solicitacao: {
        id: '',
        status: '',
        createdDate: '',
      },
      rules: {
        email: value => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'E-mail inválido.';
        },
        required: value => !!value || 'Esse campo deve ser preenchido',
        cep: value => {
          const pattern = this.patternCep;
          return pattern.test(value) || 'Cep inválido.';
        },
        cnpjValid: value => {
          const cnpj = normalizeAlphanumericCNPJ(value);
          if (cnpj.length == 14) {
            return validateAlphanumericCNPJ(cnpj) || 'CNPJ inválido.';
          }
        },
      },
      checkIfSolicitacaoEmAberto: true,
      loadingCnpj: false,
      situcaoSolicitacao: ['NAO_AUTORIZADO', 'AUTORIZADO'],
      showForm: '',
      alertMsg: true,
      cnpjIsNotvalid: false,
    };
  },
  computed: {
    ...mapState('spgc', ['formSolicitacao', 'documentosPorRegra', 'possuiSolicitacaoEmAndamento']),
    formattedCnpj: {
      get() {
        return this.formSolicitacao.cnpj;
      },
      set(value) {
        this.formSolicitacao.cnpj = formatAlphanumericCNPJ(value);
      },
    },
  },
  watch: {
    resetting(newVal, oldVal) {
      if (newVal) {
        this.showForm = '';
        this.$refs.form.reset();
      }
    },
  },

  methods: {
    resetForm() {
      if (this.$refs.form) {
        this.$refs.form.reset();
      }
    },
    emitirDocumentoSelecionado() {
      this.$emit('update:documentoSelecionado', this.documentoSelecionado);
      if (this.formSolicitacao.cnpj) {
        this.searchCnpj();
      }
    },

    searchCnpj(e) {
      // Debounce: aguarda 5 segundos após o último input antes de consultar o CNPJ
      clearTimeout(this._searchCnpjTimeout);
      let cnpj = normalizeAlphanumericCNPJ(this.formSolicitacao.cnpj);
      let isValidCnpj = validateAlphanumericCNPJ(cnpj);
      if (cnpj.length === 14 && isValidCnpj) {
        this.loadingCnpj = true;
        this._searchCnpjTimeout = setTimeout(() => {
          ServiceSolicitacao.getSolicitacaoByCnpj(cnpj).subscribe({
            next: response => {
              const { result } = response;

              this.checkIfSolicitacaoEmAberto = result.filter(solicitacao => {
                if (!this.situcaoSolicitacao.includes(solicitacao.status)) return solicitacao;
              });
              this.solicitacao = {
                ...this.checkIfSolicitacaoEmAberto[0],
                createdDate: moment(this.checkIfSolicitacaoEmAberto[0]?.createdDate).format(
                  'DD/MM/YYYY HH:mm'
                ),
              };
              //VERIFICA SE É CONSUMIDOR CATIVO LIVRE PARA PODER VERIFICAR SE JA POSSUI AUTORIZAÇÃO
              let isConsumerCativoLivre =
                this.formSolicitacao.tipoSolicitacao == 'CONSUMIDOR_CATIVO_LIVRE';
              if (isConsumerCativoLivre) {
                this.checkIfPossuiAutorizacaoConsumidorCativo(cnpj);
              } else {
                this.updateStatus();
              }
            },
            error: error => {
              this.loadingCnpj = false;
              console.error('Erro ao buscar solicitação:', error);
            },
          });
        }, 2000);
      } else {
        this.loadingCnpj = false;
        this.showForm = false;
      }
    },
    checkIfPossuiAutorizacaoConsumidorCativo(cnpj) {
      ServiceSolicitacao.verificarAutorizacaoConsumidorCativo(cnpj).subscribe({
        next: response => {
          const { result } = response;
          this.setDadosRecuperadosPreAnalise(result);
          this.setPossuiAutorizacaoConsumidorCativo(Object.keys(result).length > 0);
          this.setSolicitacaoPreAprovada(result || []);
          this.loadingCnpj = false;
          if (result) return this.updateStatus();
          // GlobalStore.setSnackBar({
          //   message: 'CNPJ não possui pré-autorização para prosseguir com a solicitação.',
          //   show: true,
          //   type: 'error',
          // });
        },
        error: error => {
          let msg = error.response?.data?.message || 'Erro ao verificar autorização.';
          GlobalStore.setSnackBar({
            message: msg,
            show: true,
            type: 'error',
          });
          this.loadingCnpj = false;
        },
      });
    },
    async baixarDocumento() {
      const url = 'https://cdn.arce.ce.gov.br/termoCompromissoSPGC.pdf';
      try {
        const response = await fetch(url);
        const blob = await response.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute('download', 'Termo de Compromisso para Fins de Autorização de Comercializador.pdf');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
      } catch (e) {
        this.$emit('showSnackbar', 'Falha ao baixar o documento.');
      }
    },
    formatarTipoSolicitacao(item) {
      if (!item || !item.tipoSolicitacao) return '';
      // Transforma CONSUMIDOR_LIVRE em Consumidor Livre
      return item.tipoSolicitacao
        .toLowerCase()
        .replace(/_/g, ' ')
        .replace(/(^|\s)\S/g, l => l.toUpperCase());
    },
    clearTipoSelecionado(tipo) {
      this.resetForm();
      this.formSolicitacao.tipoSolicitacao = null;
      this.$refs.form.reset();
    },
    formatSituacao(status) {
      return situacoesSolicitacao[status] || status;
    },

    updateStatus() {
      this.dialogProtocolo = this.checkIfSolicitacaoEmAberto?.length > 0;
      this.showForm = !this.checkIfSolicitacaoEmAberto?.length > 0;
      this.setPossuiSolicitacaoEmAndamento(this.checkIfSolicitacaoEmAberto?.length > 0);
      this.loadingCnpj = false;
      this.alertMsg = this.checkIfSolicitacaoEmAberto?.length > 0;
    },

    ...mapActions('spgc', [
      'setDocumentosPorTipoSolicitacao',
      'setPossuiSolicitacaoEmAndamento',
      'resetForm',
      'setPossuiAutorizacaoConsumidorCativo',
      'setDadosRecuperadosPreAnalise',
      'setSolicitacaoPreAprovada',
    ]),
  },
};
</script>

<style scoped>
.input-text {
  padding: 0% !important;
  margin: 0% !important;
}
</style>
